import { Command } from 'commander';
import { clearCredentials } from '../credentials.js';
import { clearActiveOrg } from '../active-org.js';
import { Output } from '../output.js';
import { addOutputOption } from '../services/output-format.js';

export interface LogoutOpts {
  json?: boolean;
  output?: string;
}

export async function runLogout(opts: LogoutOpts = {}): Promise<void> {
  const out = Output.fromOpts({ json: !!opts.json, quiet: false, output: opts.output });
  clearCredentials();
  clearActiveOrg();
  out.json(() => ({ ok: true }));
  out.human(() => '✓ Signed out. Local credentials removed.');
}

export const logoutCommand = addOutputOption(
  new Command('logout')
    .description('Sign out and clear local credentials')
    .option('--all', 'Sign out of all orgs (reserved; currently equivalent to default)')
    .option('--json', 'Machine-readable JSON output (alias of -o json)'),
).action(async (opts: LogoutOpts) => {
  await runLogout(opts);
});
